import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import url from '@/api/serviceAPI.config.js';
import { get, post, put, deletes, patch } from '@/api/fetch.js';
import axios from 'axios';
import qs from 'qs';
// 图标数组
import eIconList from '@/utils/eIconNameList/eIconList';
import elementUIList from '@/utils/eIconNameList/elementUI';
import fontAwesomeList from '@/utils/eIconNameList/fontAwesome';
export default {
  name: 'menuModule',
  data: function data() {
    return {
      isAppSelected: false,
      originalVisible: false,
      isAbled: true,
      addLoading: false,
      keyWords: {
        application: 'Web',
        name: ''
      },
      tableData: [],
      isAddShow: false,
      rules: {
        application: [{
          required: true,
          message: '请选择应用端',
          trigger: 'change'
        }],
        pid: [{
          required: true,
          message: '请选择父级层级',
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: '请选择菜单层级',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请输入菜单名称',
          trigger: 'blur'
        }],
        sort: [{
          required: true,
          message: '请输入排序',
          trigger: 'blur'
        }],
        router: [{
          required: true,
          message: '请输入路由地址',
          trigger: 'blur'
        }],
        dataStatus: [{
          required: true,
          message: '请选择是否启用',
          trigger: 'change'
        }],
        permission: [{
          required: false,
          message: '请输入权限标识',
          trigger: 'blur'
        }],
        nativeOrNot: [{
          required: true,
          message: '请选择是否原生应用',
          trigger: 'change'
        }],
        icon: [{
          required: true,
          message: '请选择图标',
          trigger: 'blur'
        }]
      },
      addForm: {
        id: '',
        application: '',
        pid: '',
        name: '',
        type: '',
        router: '',
        sort: '',
        dataStatus: '',
        nativeOrNot: 1,
        permission: '',
        icon: '',
        nonNativeAddr: ''
      },
      formLabelWidth: '110px',
      pidList: [],
      eleIconData: [],
      showIcon: false,
      // app图片上传
      fileList: [],
      imageUrl: '',
      baseUrl: url.imgUrl,
      iconOrPic: true
    };
  },
  computed: {
    applicationStatus: function applicationStatus() {
      return this.addForm.application == '' ? true : false;
    }
  },
  created: function created() {
    this.getTableData();
    // 不同图标库数组数据合并
    this.eleIconData = Object.assign(eIconList, elementUIList, fontAwesomeList);
  },
  mounted: function mounted() {},
  methods: {
    originalHandleChange: function originalHandleChange(value) {
      console.log("originalHandleChange", value);
      this.originalVisible = value ? 0 : 1;
    },
    typeChange: function typeChange(val) {
      if (val == 3) {
        this.isAbled = false;
        this.addForm.router = '';
        this.rules.permission[0].required = true;
        this.rules.router[0].required = false;
      } else if (val == 2) {
        this.isAbled = true;
        this.addForm.permission = '';
        this.rules.permission[0].required = false;
        this.rules.router[0].required = true;
      } else {
        this.isAbled = true;
        this.addForm.permission = '';
        this.rules.permission[0].required = false;
        this.rules.router[0].required = false;
      }
    },
    handleChange: function handleChange(val) {
      console.log(val);
    },
    switchChange: function switchChange(row) {
      var _this = this;
      var instence = axios.create();
      instence.post(url.menu.enable, {
        id: row.id,
        dataStatus: row.dataStatus == 1 ? 2 : 1
      }).then(function (res) {
        console.log(res);
        _this.$message.success(res.data.message);
        _this.getTableData();
      });
    },
    deleteMenu: function deleteMenu(row) {
      var _this2 = this;
      this.$confirm('是否确定删除本菜单与下级所有内容？', '提示', {
        type: 'warning'
      }).then(function () {
        _this2.listLoading = true;
        get(url.menu.delete + '?id=' + row.id).then(function (res) {
          _this2.listLoading = false;
          _this2.$message({
            message: '删除成功',
            type: 'success'
          });
          _this2.getTableData();
        });
      }).catch(function () {});
    },
    editMenu: function editMenu(row) {
      var _this3 = this;
      var id = row.id,
        dataStatus = row.dataStatus,
        pid = row.pid,
        name = row.name,
        type = row.type,
        router = row.router,
        application = row.application,
        sort = row.sort,
        icon = row.icon,
        permission = row.permission,
        nativeOrNot = row.nativeOrNot,
        nonNativeAddr = row.nonNativeAddr;
      console.log('editMenu', nativeOrNot);
      if (nativeOrNot || nativeOrNot == null) {
        this.originalVisible = false;
        this.addForm.nativeOrNot = 1;
      } else {
        this.addForm.nativeOrNot = 0;
        this.originalVisible = true;
        this.addForm.nonNativeAddr = nonNativeAddr;
      }
      this.applicationChange(application).then(function (res) {
        _this3.typeChange(type);
        Object.assign(_this3.addForm, {
          id: id,
          dataStatus: dataStatus,
          pid: pid,
          name: name,
          type: type,
          router: router,
          application: application,
          sort: sort,
          icon: icon,
          permission: permission
        });
        // 判断是number类型且值为0  将值改为字符串用于修复首次无法回显父级名称
        _this3.addForm.pid == 0 ? _this3.addForm.pid = '0' : _this3.addForm.pid;
        // 对于APP上传图片
        console.log('iconUrl', row.iconUrl);
        if (_this3.addForm.application == 'App' && row.iconUrl) {
          _this3.imageUrl = _this3.baseUrl + row.iconUrl;
        } else {
          _this3.imageUrl = '';
        }
        _this3.isAddShow = true;
      });
    },
    addSubmit: function addSubmit() {
      var _this4 = this;
      if (this.addForm.pid != "0" || this.addForm.application == 'App') {
        this.rules.icon[0].required = false;
        this.addForm.icon = '';
      } else {
        this.rules.icon[0].required = true;
      }

      // let instence = axios.create();
      if (this.addForm.file) {
        delete this.addForm.iconUrl;
      } else {
        this.addForm.iconUrl = this.imageUrl;
      }
      console.log('thisaddForm', this.addForm);
      this.$refs.addForm.validate(function (val) {
        if (val) {
          // file文件转化成二进制
          var pm = new FormData();
          for (var i in _this4.addForm) {
            var item = _this4.addForm[i];
            pm.append(i, item);
          }
          var organAxios = axios.create();
          organAxios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
          if (_this4.addForm.id) {
            organAxios.post(url.menu.edit, pm).then(function (res) {
              if (res.data.status == 200) {
                _this4.$message.success('修改成功！');
                _this4.getTableData();
                _this4.addMenuHiden();
              } else {
                _this4.$message.error(res.data.message);
              }
            });
          } else {
            organAxios.post(url.menu.add, pm).then(function (res) {
              if (res.data.status == 200) {
                _this4.$message.success('新增成功！');
                _this4.getTableData();
                _this4.addMenuHiden();
              } else {
                console.log("Res1", res);
                _this4.$message.error(res.data.message);
              }
            });
          }
        }
      });
    },
    addRoleDialogHide: function addRoleDialogHide() {
      this.isAddShow = false;
    },
    applicationChange: function applicationChange(val) {
      var _this5 = this;
      console.log("applicationChange", val);
      if (val === 'Web') {
        this.isAppSelected = false;
      } else {
        this.isAppSelected = true;
      }
      return new Promise(function (resolve, reject) {
        get(url.menu.importOnDutySettingMessage + '?application=' + val).then(function (res) {
          _this5.deleteEmptyChildren(res.data);
          _this5.pidList = [{
            id: '0',
            name: '目录',
            children: res.data
          }];

          // this.pidList = res.data;
          resolve(true);
        });
        (function (error) {
          reject(false);
        });
      });
    },
    deleteEmptyChildren: function deleteEmptyChildren(data) {
      var _this6 = this;
      data.forEach(function (item) {
        if (item.children.length) {
          _this6.deleteEmptyChildren(item.children);
        } else {
          delete item.children;
        }
      });
    },
    addMenuHiden: function addMenuHiden() {
      this.isAppSelected = false;
      this.addForm.application = '';
      this.addForm.pid = '';
      this.addForm.name = '';
      this.addForm.type = '';
      this.addForm.router = '';
      this.addForm.sort = '';
      this.addForm.dataStatus = '';
      this.addForm.id = '';
      this.addForm.icon = '';
      this.addForm.permission = '';
      this.addForm.nonNativeAddr = '';
      this.addForm.nativeOrNot = 1;
      this.pidList = [];
      this.imageUrl = '';
      delete this.addForm.file;
      this.rules.dataStatus[0].required = true;
      this.rules.permission[0].required = false;
      this.isAddShow = false;
      this.originalVisible = false;
      this.getTableData();
    },
    getTableData: function getTableData() {
      var _this7 = this;
      get(url.menu.list + qs.stringify(this.keyWords)).then(function (res) {
        _this7.keyWords.application == 'Web' ? _this7.iconOrPic = true : _this7.iconOrPic = false;
        _this7.tableData = res.data;
      });
    },
    closePopover: function closePopover(iconName) {
      this.addForm.icon = iconName;
      this.$refs.elPopover.showPopper = false;
    },
    // 上传app图片
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      console.log('file', file);
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      this.imageUrl = URL.createObjectURL(file);
      this.addForm.file = file;
      console.log('this.addform', this.addForm);
      return false;
    },
    removeAppPic: function removeAppPic() {
      var _this8 = this;
      this.$confirm('是否移除图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this8.imageUrl = '';
        delete _this8.addForm.file;
        _this8.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(function () {
        _this8.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  }
};